module.exports = __webpack_public_path__ + "media/images/athletes/1072-9880091cdf7b2eb61c661577f3cfff2e.png";